import React, { useContext, useRef } from "react";
import { IoArrowBack, IoLockClosed, IoMail } from "react-icons/io5";
import { ThemeContext } from "../../pages/qcast-logo";
import link from "../../assets/link-sent.svg";
import { useState } from "react";
import Sign from "../../api/api-sign";
import { useDispatch, useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import config from "../../config/config";
import { useEffect } from "react";

export const SignIn = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaVal, setCaptchaVal] = useState("");
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const dispatch = useDispatch();
  const recaptcha = useRef(null);

  const { login } = Sign();

  const signin = () => {
    const input = { email, password, "g-recaptcha-response": captchaVal };

    if ((showRecaptcha && captchaVal.length > 0) || !showRecaptcha) {
      login(input, ({ data, id, msg }) => {
        if (id === 200) {
          dispatch({
            type: "auth/signin",
            payload: {
              email: data.email,
              username: data.username,
              userId: data.userId,
              token: data.token,
              profileName: data.profileName,
              description: data.description,
            },
          });
          props.proceed();
        } else {
          alert(msg);
          setShowRecaptcha(true);
          setCaptchaVal("");
          recaptcha.current.reset();
        }
      });
    } else {
      alert("Complete recaptcha");
      recaptcha.current.reset();
    }
  };

  const handleRecaptcha = (value) => {
    setCaptchaVal(value);
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full" />
        </button>
        <p className="font-medium text-[#1E3053] w-fit justify-self-center whitespace-nowrap">
          Sign in
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 lg:px-[4rem] flex flex-col space-y-3 items-center pt-4 pb-6">
        <p className="text-center text-xs text-[#2C3037]">
          Please use your Qcast email and password to sign in.
        </p>
        <label className="relative w-full ">
          <IoMail color={bg} className="absolute translate-y-1/2 left-1" />
          <input
            className="h-[2rem] text-sm w-full rounded-md pl-6 pr-2 bg-[#FFFFFF4D]"
            placeholder="Email Address"
            type="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="relative w-full">
          <IoLockClosed
            color={bg}
            className="absolute translate-y-1/2 left-1"
          />
          <input
            className="h-[2rem] text-sm w-full rounded-md pl-6 pr-2 bg-[#FFFFFF4D]"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {showRecaptcha ? (
          <ReCAPTCHA
            ref={recaptcha}
            sitekey={config.recaptcha.siteKey}
            type="image"
            onChange={handleRecaptcha}
          />
        ) : (
          ""
        )}

        <span className="flex flex-row w-full">
          <button
            onClick={() => signin()}
            style={{ backgroundColor: bg, color: font }}
            className="flex-grow rounded-full p-1 shadow-md text-sm py-2"
          >
            Sign in
          </button>
        </span>
      </div>
    </div>
  );
};

export const ForgotPassword = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const [email, setEmail] = useState("");
  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false);

  const dispatch = useDispatch();
  const recaptcha = useRef(null);

  const { forgotPassword } = Sign();

  const forgotpassword = () => {
    if (isCaptchaPassed) {
      forgotPassword(email, ({ id, msg }) => {
        if (id === 200) {
          dispatch({ type: "auth/setEmail", payload: email });
          props.resetlink();
        } else {
          alert(msg);
        }
      });
    }
  };

  const handleRecaptcha = (value) => {
    console.log("Captcha value:", value);
    setIsCaptchaPassed(true);
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full" />
        </button>
        <p className="font-medium w-fit justify-self-cenetr text-[#1E3053] whitespace-nowrap">
          Forgot password
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 flex flex-col gap-3 items-center pt-4 pb-6">
        <p className="text-center text-sm text-[#2C3037]">
          Enter the email you usually use to sign in to Qcast and we'll send you
          a password reset link.
        </p>
        <span className="w-full flex flex-col items-center gap-2 px-8">
          <label className="relative w-full ">
            <IoMail color={bg} className="absolute translate-y-[65%] left-1" />
            <input
              className="h-[2.5rem] text-sm w-full rounded-md pl-6 pr-2 bg-[#FFFFFF80]"
              placeholder="Email Address"
              value={email}
              type="email"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <ReCAPTCHA
            ref={recaptcha}
            sitekey={config.recaptcha.siteKey}
            type="image"
            onChange={handleRecaptcha}
          />
          <button
            style={{ backgroundColor: bg, color: font }}
            className="text-xs py-2 w-[75%] flex-grow rounded-full p-1"
            onClick={() => forgotpassword()}
          >
            Send password reset link
          </button>
        </span>
      </div>
    </div>
  );
};

export const ForgotPasswordLinkSent = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const userEmail = useSelector((state) => state.auth.email);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch({ type: "auth/setEmail", payload: "" });
  });

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053] whitespace-nowrap">
          Forgot password
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 lg:px-[4rem] flex flex-col gap-3 items-center pt-4 pb-6">
        <p className="text-center text-sm text-[#2C3037]">
          We've sent your password reset link to{" "}
          <strong style={{ color: bg }}>{userEmail}</strong>
        </p>
        <p className="text-sm">Please check our email</p>
        <img alt="" src={link} className="w-[8rem]" />
        <button
          style={{ backgroundColor: bg, color: font }}
          className="w-[70%] flex-grow rounded-full p-1 text-sm py-2"
          onClick={props.signin}
        >
          Sign in
        </button>
      </div>
    </div>
  );
};
